import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import TopNav from "@/components/TopNav";

const NAV_ROUTES = ["/", "/browse", "/cart", "/account"];

export default function Layout() {
  const loc = useLocation();
  const showNav = NAV_ROUTES.includes(loc.pathname);
  return (
    <div className="k-frame" dir="rtl">
      {showNav && <TopNav />}
      <div className="k-scroll" id="k-scroll">
        <Outlet />
      </div>
    </div>
  );
}
